export default {
  name: "Minus",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d: "M27 16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1 1 1 0 0 1 1-1h20a1 1 0 0 1 1 1z",
  },
}
